import { render, staticRenderFns } from "./refresh-on-create-toggle.vue?vue&type=template&id=5fd34de5&scoped=true"
import script from "./refresh-on-create-toggle.vue?vue&type=script&lang=js"
export * from "./refresh-on-create-toggle.vue?vue&type=script&lang=js"
import style0 from "./refresh-on-create-toggle.vue?vue&type=style&index=0&id=5fd34de5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd34de5",
  null
  
)

export default component.exports